import {createYandexMapHelper} from '../../classes/yandex-map-helper/yandex-map-helper/init-yandex-map';
import {YMAPS_API_KEY} from '../../classes/yandex-map-helper/constants';

const PLACEMARK_MANAGER_ID = 'placemark-manager';
let DATA_JSON;

const renderDots = ( yandexMapHelper ) => {
	if ( !DATA_JSON )
	{
		return;
	}

	const placemarksManager = yandexMapHelper.createObjectManager( PLACEMARK_MANAGER_ID, {
		clusterize: false,
		zIndex: 1,
	} );

	DATA_JSON.forEach( ( {station}, index ) => {
		const {latitude, longitude, line_hex_color, is_ready} = station;
		
		if ( !latitude || !longitude )
		{
			return;
		}

		const placemarkProps = {
			type: 'Feature',
			id: `${index}`,
			geometry: {
				type: 'Point',
				coordinates: [latitude, longitude],
			},
			properties: {},
			options: {
				iconLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
					`<div class="circle-point ${is_ready === 'yes' ? 'open' : 'close'}" style="var(--station-color: ${line_hex_color})"></div>`,
					{
						build() {
							this.constructor.superclass.build.call( this );

							const placemark = this.getElement().querySelector( 'div.circle-point' );

							if ( placemark )
							{
								const width = placemark.offsetWidth;
								const height = placemark.offsetHeight;

								const shapeCoordinates = [
									[width / -2, -1 * height],
									[width / 2, width / 2],
								];

								const shapeRectangle = {
									type: 'Rectangle',
									coordinates: shapeCoordinates,
								};

								this.getData().options.set( 'shape', shapeRectangle );

								placemark.style.setProperty( 'position', 'absolute' );

								if ( is_ready === 'yes' )
								{
									placemark.style.setProperty( 'left', '-10px' );
									placemark.style.setProperty( 'top', '-10px' );
								}
								else
								{
									placemark.style.setProperty( 'left', '-12px' );
									placemark.style.setProperty( 'top', '-12px' );
								}
							}
						},
					},
				),
				zIndex: 1,
			},
		};

		placemarksManager.add( placemarkProps );
	} );
};

const initLines = ( yandexMapHelper ) => {
	if ( !DATA_JSON )
	{
		return;
	}

	const lines = [];
	const linesColors = [];
	const allLinesLayer = [];

	DATA_JSON.forEach( ( {station} ) => {
		if ( station.longitude === '' || station.longitude === '' )
		{
			return;
		}

		if ( lines[station.line_number] && lines[station.line_number] )
		{
			lines[station.line_number].push( [station.latitude, station.longitude] );
		} else {
			lines[station.line_number] = [];
			lines[station.line_number].push( [station.latitude, station.longitude] );
		}

		linesColors[station.line_number] = station.line_hex_color;
	} );

	lines.forEach( ( line, index ) => {
		yandexMapHelper.yandexMap.geoObjects.add(
			allLinesLayer[index] = new yandexMapHelper.ymaps.Polyline(
				line,
				{},
				{
					strokeColor: linesColors[index],
					strokeWidth: 5,
					strokeOpacity: '1',
				},
			),
		);
	} );
};

const initMap = ( yandexMapHelper ) => {
	yandexMapHelper.addZoomControls( {
		position: {
			top: 32,
			right: 32,
			bottom: 'auto',
			left: 'auto',
		},
	} );

	renderDots( yandexMapHelper );
	initLines( yandexMapHelper );
};

const initProjectMap = ( mapContainer, data, component ) => {
	if ( mapContainer && data )
	{
		DATA_JSON = JSON.parse( data );
		const coords = [];

		DATA_JSON.forEach( ( {station} ) => {
			if ( station.is_current === '1' )
			{
				coords.push( station.latitude );
				coords.push( station.longitude );
			}
		} );

		const mapProps = {
			ymapsApiKey: YMAPS_API_KEY,
			mapContainer,
			mapState: {
				center: coords,
			},
			mapOptions: {
				minZoom: 15,
				maxZoom: 19,
			},
			component,
			readyCallback: initMap,
		};
		
		createYandexMapHelper( mapProps );
	}
};

export {
	initProjectMap,
};
